// T-165: a server-rendered fragment fetched in place — the data grid (grid.ts) and the calendar (calendar-view.ts) ask for
// their own partial with a request header, parse it in an inert <template> (its scripts never run) and keep the address in
// step. One way for both, so a fix to one is a fix to the other.

/** How a load changes the address: a new history entry, the same entry, or none. */
export type HistoryMode = 'push' | 'replace' | null;

/** What came back: the fragment's root (null for a sign-in page, a redirect or an error page) and the status. */
export interface Fragment {
  element: HTMLElement | null;
  status: number;
}

/** Fetches <paramref>url</paramref> with the fragment header and returns its root element, matched by <paramref>selector</paramref>. */
export async function fetchFragment(
  url: string,
  header: string,
  value: string,
  selector: string,
  signal?: AbortSignal,
): Promise<Fragment> {
  const res = await fetch(url, { headers: { [header]: value }, credentials: 'same-origin', signal });
  const html = res.ok ? await res.text() : '';
  const tpl = document.createElement('template');
  tpl.innerHTML = html.trim();
  return { element: tpl.content.querySelector<HTMLElement>(selector), status: res.status };
}

/** Records the load in the browser's history as <paramref>mode</paramref> says. */
export function remember(mode: HistoryMode, state: unknown, url: string): void {
  if (mode === 'push') window.history.pushState(state, '', url);
  else if (mode === 'replace') window.history.replaceState(state, '', url);
}
